import { render, staticRenderFns } from "./v20d7010pc.vue?vue&type=template&id=0d2e2ba5&"
import script from "./v20d7010pc.vue?vue&type=script&lang=js&"
export * from "./v20d7010pc.vue?vue&type=script&lang=js&"
import style0 from "./v20d7010pc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports